import { Box } from "@material-ui/core"
import CheckboxCheckedIcon from "components/Icons/CheckboxCheckedIcon"
import CheckboxIcon from "components/Icons/CheckboxIcon"
import NextLink from "components/Reusable/Bit/NextLink"
import FormikCheckbox from "components/Reusable/FormsComp/FormikCheckbox"
import { useFormikContext } from "formik"
import { useEffect } from "react"
import styled from "styled-components"
import { useGroupPurchasesContext } from "./GroupPurchasesContext"

const StyledWrapper = styled(Box)<{ $margin?: string; $mobileMargin?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: ${(p) => p?.$margin || "60px 0 20px 0"};
  position: relative;
  div {
    :nth-child(2) {
      margin-top: 20px;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin: ${(p) => p?.$mobileMargin || "30 0 0 0"}px;
    .Mui-error {
      top: 16px;
    }
  }
  label {
    color: #000;
    ${(p) => p.theme.breakpoints.down("sm")} {
      text-align: right;
      line-height: 1;
    }
  }
  label a {
    text-decoration: none;
    font-weight: bold;
    margin-right: 5px;

    :hover {
      text-decoration: underline;
    }
  }
`

const StyledLabelText = styled.label`
  font-size: 20px;
`

type LegalCheckboxessProps = {
  saveGiftCardData: (values: object) => void
  margin?: string
  mobileMargin?: string
  setValues?: any
  prevPageId?: number
}

const LegalCheckboxes = ({
  saveGiftCardData,
  margin,
  mobileMargin,
  setValues,
  prevPageId,
}: LegalCheckboxessProps) => {
  const { values } = useFormikContext<any>()

  const { setPrevPageId } = useGroupPurchasesContext()

  useEffect(() => {
    if (setValues) {
      setValues(values)
    }
  }, [values, setValues])

  return (
    <StyledWrapper $margin={margin} $mobileMargin={mobileMargin}>
      <FormikCheckbox
        name="checkedOne"
        normalIcon={<CheckboxIcon />}
        checkedIcon={<CheckboxCheckedIcon />}
        checked={values?.checkedOne || undefined}
        ariaLabel="צ׳קבוקס שמאשר את תנאי השימוש"
        ariaDescribedBy="terms-description"
      >
        <StyledLabelText id="terms-description">
          אני מאשר/ת את
          <NextLink
            href="/terms"
            onClick={() => {
              saveGiftCardData(values)
              prevPageId && setPrevPageId(prevPageId)
            }}
            openInNewTab
          >
            תנאי השימוש
          </NextLink>
        </StyledLabelText>
      </FormikCheckbox>
      <FormikCheckbox
        name="checkedTwo"
        normalIcon={<CheckboxIcon />}
        checkedIcon={<CheckboxCheckedIcon />}
        checked={values?.checkedTwo || undefined}
        ariaLabel="צ׳קבוקס שמאשר את קבלת תוכן שיווקי במסרונים/מייל ובכל דרך אחרת"
        ariaDescribedBy="marketing-description"
      >
        <StyledLabelText id="marketing-description">
          אני מאשר/ת קבלת תוכן שיווקי במסרונים/מייל ובכל דרך אחרת
        </StyledLabelText>
      </FormikCheckbox>
    </StyledWrapper>
  )
}

export default LegalCheckboxes
